import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { ACCOUNT_DELETE_COPY } from '@saesak/shared';
import { AppBar, Screen } from '@/components/layout';
import { Button, Card, ErrorNote, Field, Input } from '@/components/ui';
import { ApiError, apiData } from '@/lib/api';
import { useAuth } from '@/store/auth';

/**
 * 계정 탈퇴 (§5.1, §14.1 스토어 요건) — 삭제·보존 범위를 먼저 보여 주고,
 * 확인 문구를 입력해야 실행된다. 성공하면 로컬 세션을 지우고 로그인으로 돌아간다.
 */
export function DeleteAccountPage() {
  const logout = useAuth((s) => s.logout);
  const [phrase, setPhrase] = useState('');
  const [error, setError] = useState<string | null>(null);

  const remove = useMutation({
    mutationFn: () => apiData<{ ok: true }>('/auth/account/delete', { method: 'POST', body: {} }),
    onSuccess: () => {
      window.alert(ACCOUNT_DELETE_COPY.done);
      void logout();
    },
    onError: (caught) =>
      setError(caught instanceof ApiError ? caught.message : '처리하지 못했어요. 다시 시도해 주세요.'),
  });

  return (
    <Screen withNav={false}>
      <AppBar title={ACCOUNT_DELETE_COPY.title} back />

      <div className="flex flex-col gap-4 p-4">
        <p className="text-base font-semibold">{ACCOUNT_DELETE_COPY.intro}</p>

        <Card>
          <p className="mb-1.5 text-sm font-semibold text-notice">{ACCOUNT_DELETE_COPY.removedTitle}</p>
          <ul className="flex flex-col gap-1 text-sm text-ink-sub">
            {ACCOUNT_DELETE_COPY.removedItems.map((item) => (
              <li key={item}>· {item}</li>
            ))}
          </ul>
        </Card>

        <Card>
          <p className="mb-1.5 text-sm font-semibold text-primary-strong">{ACCOUNT_DELETE_COPY.keptTitle}</p>
          <ul className="flex flex-col gap-1 text-sm text-ink-sub">
            {ACCOUNT_DELETE_COPY.keptItems.map((item) => (
              <li key={item}>· {item}</li>
            ))}
          </ul>
          <p className="mt-2 text-sm text-ink-sub">{ACCOUNT_DELETE_COPY.directorNote}</p>
        </Card>

        <Field label={ACCOUNT_DELETE_COPY.confirmGuide}>
          <Input
            value={phrase}
            onChange={(e) => setPhrase(e.target.value)}
            placeholder={ACCOUNT_DELETE_COPY.confirmPhrase}
          />
        </Field>

        {error && <ErrorNote message={error} />}

        <Button
          block
          variant="danger"
          disabled={phrase.trim() !== ACCOUNT_DELETE_COPY.confirmPhrase}
          loading={remove.isPending}
          onClick={() => remove.mutate()}
        >
          {ACCOUNT_DELETE_COPY.submit}
        </Button>
      </div>
    </Screen>
  );
}
